// src/api/corralPricingAdminApi.ts
import client from "./client";

export interface PricingTier {
  id: string;
  quantity: number | null;
  discountPercentage: number | null;
  fixedPrice: number | null;
  unlimited: boolean;
  active: boolean;
  sortOrder: number;
  total: number | null;
}

export interface PricingCatalog {
  basePrice: number;
  currency: string;
  tiers: PricingTier[];
}

interface AdminEnvelope<T> {
  code: number;
  message: string;
  content: T;
}

export const corralPricingAdminApi = {
  obtener: () =>
    client.get<AdminEnvelope<PricingCatalog>>("/api/v1/admin/corrals/pricing"),

  actualizarBase: (basePrice: number, currency = "COP") =>
    client.put<AdminEnvelope<unknown>>("/api/v1/admin/corrals/pricing/base", {
      basePrice,
      currency,
    }),

  crearTier: (payload: {
    quantity?: number;
    discountPercentage?: number;
    fixedPrice?: number;
    unlimited: boolean;
    active?: boolean;
    sortOrder?: number;
  }) =>
    client.post<AdminEnvelope<PricingTier>>(
      "/api/v1/admin/corrals/pricing/tiers",
      payload,
    ),

  actualizarTier: (
    id: string,
    payload: {
      quantity?: number;
      discountPercentage?: number;
      fixedPrice?: number;
      unlimited: boolean;
      active?: boolean;
      sortOrder?: number;
    },
  ) =>
    client.put<AdminEnvelope<PricingTier>>(
      `/api/v1/admin/corrals/pricing/tiers/${id}`,
      payload,
    ),
};
